// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['nl_NL']  = {
  "name": "nl_NL",
  "day": {
    "abbrev": [
      "zo",
      "ma",
      "di",
      "wo",
      "do",
      "vr",
      "za"
    ],
    "full": [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "feb",
      "mrt",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d-%m-%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

